<template>
  <el-dialog
    :append-to-body="true"
    :show-close="true"
    class="inspect-dialog"
    :style="{ width: lang === 'en' ? '1110px' : '1010px' }"
    center
    align-center
    :model-value="dialogVisible"
    @closed="close"
  >
    <div class="flex">
      <div class="inspect-info animation-height" :style="{ width: lang === 'en' ? '1110px' : '1010px' }">
        <div class="flex">
          <div class="info-left">
            <div class="info-img relative flex flex-col items-center">
              <div
                class="absolute left-0 right-0"
                :style="{
                  top: '-25px'
                }"
                v-if="selectItem?.assetVO?.inspectImgs && selectItem?.assetVO?.inspectImgs.length"
              >
                <img v-for="(img, index) in selectItem?.assetVO?.inspectImgs" :key="index" :src="img" alt="" />
              </div>

              <img v-else :src="selectItem?.classInfoVO?.imageUrl" alt="" />

              <div class="action-list flex items-center justify-end">
                <a :href="selectItem?.assetVO?.inspectUrl" class="btn flex w-140 items-center justify-center" target="_blank">
                  <i class="iconfont icon-CS2 text-color-white mr-5 text-20"></i>
                  <span class="text-color-white text-14">{{ $t('游戏中检视') }}</span>
                </a>
              </div>
            </div>
            <div style="width: 400px" class="mt-20">
              <el-tooltip :content="$t('点击复制名称')" placement="bottom" effect="dark">
                <div class="item-name pointer text-22 font-semibold leading-snug" @click="copyText(selectItem?.classInfoVO?.name)">
                  {{ selectItem?.classInfoVO?.name }}
                </div>
              </el-tooltip>
              <div class="mt-17 flex items-center justify-between">
                <div>
                  <span class="wear-tag mr-10 text-white" :style="{ backgroundColor: CS_EXTERIOR[selectItem?.exterior?.nameZh]?.color, padding: '2px 12px' }">
                    {{ selectItem?.exterior?.nameZh }}
                  </span>
                  <span
                    class="st-tag text-white"
                    :style="{
                      backgroundColor: `${CS_QUALITY[selectItem?.quality?.nameZh]?.color}`,
                      padding: '2px 12px'
                    }"
                  >
                    {{ selectItem?.quality?.nameZh }}
                  </span>
                </div>
              </div>
              <div class="mt-12 h-61 rounded border border-[#DDDFE7] px-14 py-10">
                <div class="text-color-lightgray mb-5">{{ $t('磨损') }}：{{ selectItem?.assetVO?.floatWear }}</div>
                <wearbar :wear="selectItem?.assetVO?.floatWear" />
              </div>
              <div class="mt-10 flex h-46 items-center rounded border border-[#DDDFE7] pl-10 text-16 text-[#979CAE]">
                <span>{{ $t('饰品指纹') }}:</span>
                <span class="ml-10 w-265 overflow-hidden text-ellipsis whitespace-nowrap">{{ selectItem?.assetVO?.fingerprint }}</span>
                <i class="iconfont icon-fuzhi ml-16 cursor-pointer text-16" @click="copyText(selectItem?.assetVO?.fingerprint)"></i>
              </div>
              <div class="mt-10 flex">
                <div class="text-color-lightgray mr-20 flex h-46 w-195 items-center justify-between rounded border border-[#DDDFE7] px-14">
                  <span>{{ $t('图案模板') }}:</span>
                  <span
                    >{{ selectItem?.assetVO?.paintSeed }}
                    <span
                      v-if="
                        commonDictionary?.specialStyleMap[selectItem?.assetVO?.specialStyleAndFade?.specialStyle?.toLowerCase()]?.group &&
                        commonDictionary?.specialStyleMap[selectItem?.assetVO?.specialStyleAndFade?.specialStyle?.toLowerCase()]?.group != 'phase'
                      "
                      :style="{
                        color: commonDictionary?.specialStyleMap[selectItem?.assetVO?.specialStyleAndFade?.specialStyle?.toLowerCase()]?.color
                      }"
                    >
                      {{ `(${commonDictionary?.specialStyleMap[selectItem?.assetVO?.specialStyleAndFade?.specialStyle?.toLowerCase()]?.alias})` }}
                    </span>
                  </span>
                </div>
                <div class="text-color-lightgray flex h-46 w-195 items-center justify-between rounded border border-[#DDDFE7] px-14">
                  <span>{{ $t('皮肤编号') }}:</span>
                  <span
                    >{{ selectItem?.assetVO?.paintIndex }}

                    <span
                      v-if="commonDictionary?.specialStyleMap[selectItem?.assetVO?.specialStyleAndFade?.specialStyle?.toLowerCase()]?.group == 'phase'"
                      :style="{
                        color: commonDictionary?.specialStyleMap[selectItem?.assetVO?.specialStyleAndFade?.specialStyle?.toLowerCase()]?.color
                      }"
                    >
                      ({{ commonDictionary?.specialStyleMap[selectItem?.assetVO?.specialStyleAndFade?.specialStyle?.toLowerCase()]?.alias }})
                    </span></span
                  >
                </div>
              </div>

              <div :class="`flex items-center` + (selectItem?.assetVO?.stickers?.length || selectItem?.assetVO?.keychains?.length ? ' mt-10' : '')">
                <div class="sticker-list flex" v-if="selectItem?.assetVO?.keychains?.length">
                  <mytooltip v-for="keychain in selectItem?.assetVO?.keychains" :key="keychain.id" placement="bottom">
                    <a :href="localePath(`/cs2/${keychain.marketHashName}`)" target="_blank">
                      <div class="pointer mr-5 text-center">
                        <img :src="keychain.imgUrl" class="w-40" alt="" />
                        <div class="text-color-lightgray mt-8">挂件</div>
                      </div>
                    </a>
                    <template #content>
                      <div class="py-20 text-14 text-gray-light">
                        <div class="mb-10">{{ keychain?.name }}</div>
                        <div>
                          <span class="text-black">{{ $t('价格') }}: </span>
                          <span class="text-color-orange">{{ monetaryUnit() }}{{ keychain.evaluatePrice ? currencyTransform(keychain?.evaluatePrice) : '-' }}</span>
                        </div>
                      </div>
                    </template>
                  </mytooltip>
                </div>
                <div v-if="selectItem?.assetVO?.keychains?.length && selectItem?.assetVO?.stickers?.length" class="ml-6 mr-7 h-40 w-1" style="background: #dddfe7"></div>
                <div class="sticker-list flex">
                  <mytooltip v-for="sticker in selectItem?.assetVO?.stickers" :key="sticker.stickerId" placement="bottom">
                    <a :href="localePath(`/cs2/${sticker.marketHashName}`)" target="_blank">
                      <div class="pointer mr-5 text-center">
                        <img :src="sticker.imgUrl" class="w-40" alt="" />
                        <div class="text-color-lightgray mt-8">{{ parseInt((1 - sticker.wear) * 100) }}%</div>
                      </div>
                    </a>
                    <template #content>
                      <div class="py-20 text-14 text-gray-light">
                        <div class="mb-10">{{ sticker?.name }}</div>
                        <div>
                          <span class="text-black">{{ $t('价格') }}: </span>
                          <span class="text-color-orange">{{ monetaryUnit() }}{{ sticker.evaluatePrice ? currencyTransform(sticker?.evaluatePrice) : '-' }}</span>
                        </div>
                      </div>
                    </template>
                  </mytooltip>
                </div>

                <div class="ml-10 flex flex-col items-center">
                  <div v-if="selectItem?.assetVO?.stickers?.length" class="text-14 text-[#979CAE]">
                    <div>{{ $t('已贴印花市场价') }}</div>
                    <div class="text-[#F87600]">¥{{ calMarketPrice(selectItem?.assetVO?.stickers) }}</div>
                  </div>
                </div>
              </div>
              <div class="mt-10 text-24 font-semibold text-[#F87600]">{{ monetaryUnit() }}{{ currencyTransform(selectItem?.assetVO?.evaluatePrice) }}</div>
            </div>
          </div>
          <div class="info-right ml-20 w-630">
            <div class="mb-10 text-16 font-semibold">
              {{ $t('历史拥有者') }}
              <span v-if="trackerData && trackerData[0]"
                >({{ $t('累计换手') }}<span style="color: #0252d9" class="ml-3 mr-3">{{ trackerData.length }}</span
                >{{ $t('次') }})</span
              >
            </div>
            <div v-loading="showHistoryLoading" class="item-history">
              <div v-if="trackerData && trackerData[0]" class="history-data">
                <div class="">
                  <div v-if="lastTradeTime" class="text-color-lightgray mt-5">{{ $t('上次交易时间') }} {{ dayjs(lastTradeTime * 1000).format('YYYY/MM/DD HH:mm:ss') }}</div>
                </div>
                <div class="avatar-details">
                  <div class="owner-item flex items-center" v-for="(item, index) in trackerData" :key="index">
                    <span class="pot"></span>
                    <div class="line" v-if="index !== trackerData.length - 1"></div>
                    <div class="pl-20" :style="{ width: lang === 'en' ? '200px' : '170px' }">
                      <div v-if="index == 0 && item.inInventory" class="current-owner" :style="{ width: lang === 'en' ? '120px' : '80px' }">{{ $t('当前拥有者') }}</div>
                      <div v-if="trackerData.length > 1 && index == trackerData.length - 1" class="lastest-owner" :style="{ width: lang === 'en' ? '120px' : '80px' }">
                        {{ $t('最早拥有者') }}
                      </div>
                      <div class="mt-2 flex h-20 items-center text-14">
                        {{ dayjs(item.ownerTime * 1000).format('YYYY/MM/DD') }} <span class="ml-5" v-if="item?.beforeDay">{{ $t('{day}天前', { day: item.beforeDay }) }}</span>
                      </div>
                    </div>
                    <div class="ml-29 cursor-pointer" @click="openInventory(item.steamId)">
                      <div class="flex w-140">
                        <el-avatar class="img m-[auto]" :src="item.avatar">
                          <img src="https://avatars.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg" alt="avatar" />
                        </el-avatar>
                        <div class="ml-10 w-90 text-14">
                          <div class="flex h-20 w-90 items-center truncate" style="color: #000">{{ item.nickname }}</div>
                          <div class="flex h-17 items-center">{{ $t('{level}级', { level: item.level }) }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="ml-10 text-14" :style="{ width: lang === 'en' ? '150px' : '90px' }">
                      <div class="flex h-20 items-center truncate font-semibold" style="color: #f87600">{{ monetaryUnit() }}{{ item.tradePrice }}</div>
                      <div class="flex h-17 items-center">{{ $t('购入时底价') }}</div>
                    </div>

                    <div class="ml-10 w-90 text-14">
                      <div class="flex h-20 w-90 items-center truncate" style="color: #000">{{ item.playtime }}h</div>
                      <div class="flex h-17 items-center">{{ $t('游戏时长') }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="history-empty flex items-center justify-center">
                <div v-if="userInfo?.nickname" class="text-center">
                  <p class="text-color-gray text-16">{{ $t('抱歉，您的饰品追踪可用次数不足，分享可得追踪次数') }}</p>
                  <el-button class="mt-32" @click="copyShare">
                    <el-row align="middle" class="text-color-white text-16">
                      <i class="iconfont icon-lianjie mr-5 text-18"></i>
                      <span>{{ $t('分享链接') }}</span>
                    </el-row>
                  </el-button>
                  <p class="text-color-orange mt-10 text-14">{{ $t('成功分享次数+1') }}</p>
                </div>

                <div v-else class="flex flex-col items-center">
                  <p class="text-color-gray text-16">{{ $t('您还没有登录，请登录后查看该饰品历史持有人') }}</p>

                  <el-button class="mt-32" @click="steamLogin">
                    <span class="text-color-white text-16">{{ $t('点击登录') }}</span>
                  </el-button>
                </div>
              </div>
            </div>

            <div class="text-color-lightgray mb-20 flex h-200 items-start rounded py-14" style="border-top: 1px solid #dddfe7">
              <div class="mr-10 w-70">
                <img src="https://cdn.steamdt.com/category/trend-dialog/robot.png" alt="" style="width: 70px; height: 92px" />
              </div>
              <p
                class="ml-10 h-190 overflow-y-auto"
                v-if="itemDesc"
                style="line-height: 30px"
                v-html="itemDesc"
                :style="{ lineHeight: '30px', width: lang === 'en' ? '550px' : '450px' }"
              ></p>
            </div>

            <div class="btn-share mt-20 flex items-center justify-between">
              <div class="share-btn" @click="shareLink(selectItem?.assetVO?.fingerprint)">
                <i class="iconfont icon-fenxiang mr-10 text-20"></i>
                <span class="text-14">{{ $t('分享') }}</span>
              </div>
              <a :href="localePath(`/cs2/${selectItem?.classInfoVO?.marketHashName}`)" target="_blank">
                <div class="share-btn">
                  <i class="iconfont icon-qushi mr-10 text-20"></i>
                  <span class="text-14">{{ $t('查看走势') }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import wearbar from '~/components/common/wearbar.vue'
import mytooltip from '~/components/common/mytooltip.vue'
import copyShareUrl from '~/utils/copyshareUrl'

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import relativeTime from 'dayjs/plugin/relativeTime'
import { copy } from '#imports'
import { CS_EXTERIOR, CS_QUALITY } from '~~/constants/item'
import { add, handleTagMap } from '~/utils/index'
import { getItemDesc, getTraceInfo } from '~~/api/steam'
import { getCommonDictionary } from '~~/api/common'

dayjs.extend(relativeTime)
dayjs.locale('zh-cn')

const lang = useI18n().locale.value

const store = useNuxtStore()
const userInfo = store.userInfo
const route = useRoute()
const router = useRouter()

const emit = defineEmits(['close'])
const props = defineProps({
  item: {
    type: Object,
    default: () => {
      return {}
    }
  },
  list: {
    type: Array,
    default: () => {
      return []
    }
  },
  dialogVisible: {
    type: Boolean,
    default: false
  }
})
let trackerData = ref([])
let selectItem = ref(props.item)
const bIsShowHistory = ref(false)
const showHistoryLoading = ref(false)
const lastTradeTime = ref() //上次交易时间

const { data: commonDictionary } = await useAsyncData(getCommonDictionary, {
  server: false
})


const { data: itemDesc } = await getItemDesc({ typeVal: props.item?.assetVO?.itemId })


onMounted(() => {
  selectItem.value && handleTagMap(selectItem.value, commonDictionary.value, 'classInfoVO')

  if (userInfo?.nickname && selectItem.value) {
    readHistory()
    // 更改路由参数
    const newQuery = Object.assign({}, route.query, { hash: selectItem.value.assetVO?.fingerprint })
    router.push({
      path: '',
      query: newQuery
    })
  }
})

const openInventory = steamId => {
  window.open(`/inventory/${steamId}`, '_blank')
}

function select(skin) {
  bIsShowHistory.value = false
  selectItem.value = skin
}

function close() {
  emit('close')
}

// 计算印花市场在售价的总和
function calMarketPrice(stickers) {
  let price = 0
  stickers.forEach(config => {
    price = add(price, config.evaluatePrice ?? 0)
  })
  return price
}

// 读取历史拥有者
const readHistory = () => {
  showHistoryLoading.value = true
  getTraceInfo({
    content: selectItem.value.assetVO?.fingerprint,
    marketHashName: selectItem.value.classInfoVO?.marketHashName || '',
    specialStyle: selectItem.value?.assetVO?.specialStyleAndFade?.specialStyle || ''
  })
    .then(res => {
      showHistoryLoading.value = false
      trackerData.value = res.data?.traceVO?.itemTraceVOList
      lastTradeTime.value = res.data?.traceVO?.updateTime
      if (res.data.traceTimes) {
        const store = useNuxtStore()
        const userInfo = JSON.parse(JSON.stringify(store.userInfo))
        userInfo.traceTimes = res.data.traceTimes
        store.setUserInfo(userInfo)
      }
    })
    .catch(err => {
      showHistoryLoading.value = false
      trackerData.value = []
    })
}

// 查看历史拥有者
const showHistory = () => {
  bIsShowHistory.value = !bIsShowHistory.value
  readHistory()
}

// 头部分享
const shareLink = id => {
  copy(window.location.href)
  myMessage({
    message: '分享链接已复制'
  })
}

// 复制
const copyText = val => {
  copy(val)
  myMessage({ message: '复制成功', type: 'success' })
}

// 分享链接复制
const copyShare = () => {
  const remainTime = copyShareUrl()
  myMessage({
    type: 'success',
    message: '分享链接已复制',
    duration: 2000
  })
  userInfo.value = {
    ...userInfo.value,
    traceTimes: remainTime
  }
  store.setUserInfo(userInfo)
}

// 登录
const steamLogin = () => {
  const store = useNuxtStore()
  store.setLoginDialog(true)
  emit('close')
}
</script>

<style lang="scss">
@import url('~/assets/styles/_color.scss');

.inspect-dialog {
  box-sizing: border-box;
  padding: 0;
  background: transparent !important;
  z-index: 6;
  .el-dialog__header {
    padding: 0 !important;

    .el-dialog__headerbtn {
      width: 16px;
      height: 16px;
      line-height: 1;
      font-size: 16px;
      top: 16px;
      right: 16px;

      .el-dialog__close {
        width: 16px;
        height: 16px;
        line-height: 16px;
        font-family: 'iconfont';
        font-style: normal;

        &:hover {
          animation: loading 0.4s linear;
        }

        &::before {
          content: '\e6d2';
        }

        svg {
          display: none;
        }
      }
    }
  }

  .arrow-top {
    width: 120px;
    height: 45px;
    background: #ffffff;
    border-radius: 4px;
  }
  .sale-list {
    scrollbar-width: none;
  }
  .inspect-list {
    width: 120px;
  }
  .arrow-bottom {
    width: 120px;
    height: 45px;
    background: #ffffff;
    border-radius: 4px;
  }
  .inspect-item {
    width: 120px;
    height: 95px;
    background: linear-gradient(180deg, #e6eef9 0%, #f7fafd 100%);
    border-radius: 4px;
    position: relative;
    &.active {
      border: 2px solid #0252d9;
    }
  }
  .inspect-img {
    width: 100px;
    height: 75px;
  }
  .inspect-price {
    width: 120px;
    height: 23px;
    background: linear-gradient(90deg, rgba(248, 118, 0, 0.3) 0%, rgba(248, 118, 0, 0) 50%, transparent 70%);
    border-radius: 0px 4px 4px 4px;
    position: absolute;
    left: 0;
    bottom: 0;
    color: #f87600;
  }
  .inspect-info {
    background: #ffffff;
    border-radius: 10px;
    padding: 30px;
    box-sizing: border-box;
  }
  .info-img {
    width: 400px;
    height: 400px;
    border-radius: 10px;
    background: url(https://resources.zbt.com/steam-stock/index/item-detail-dialog/dialog-bg.webp) center no-repeat;
    background-size: cover;
    overflow: hidden;

    .action-list {
      position: absolute;
      right: 20px;
      bottom: 20px;
      left: 20px;

      .btn {
        height: 36px;
        background: rgba($black-color, 0.6);
        border-radius: 10px;
        border: 0 none;
      }
    }
  }

  .item-history {
    transition: height 0.3s ease;
    transition-delay: 0.3s;

    .history-data {
      height: 480px;
    }

    .avatar-details {
      color: $light-gray-color;
      height: 447px;
      overflow: hidden;
      overflow-y: auto;
      .owner-item {
        position: relative;
        height: 80px;
        line-height: 80px;
        .pot {
          width: 10px;
          height: 10px;
          background: #ffffff;
          border: 1px solid #979cae;
          border-radius: 50%;
          display: inline-block;
          position: absolute;
          top: 37px;
          left: 0;
        }
        .line {
          border-left: 1px dotted #dddfe7;
          height: 79px;
          width: 1px;
          position: absolute;
          left: 5px;
          top: 47px;
        }
      }

      .img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #8e3331;
      }
    }

    .current-owner {
      color: #ffffff;
      height: 18px;
      background: #f87600;
      border-radius: 2px;
      text-align: center;
      width: 80px;
      line-height: 18px;
    }
    .lastest-owner {
      color: #ffffff;
      height: 18px;
      background: #0dab62;
      border-radius: 2px;
      text-align: center;
      line-height: 18px;
      width: 80px;
    }

    .history-empty {
      background: rgba(215, 227, 247, 0.4);
      width: 530px;
      height: 468px;
      border-radius: 10px;
      border: 1px solid rgba(202, 208, 220, 0.5);

      .el-button {
        width: 180px;
        height: 46px;
        line-height: 46px;
        border-color: $primary-color;
        background-color: $primary-color;
        border-radius: 4px;
      }
    }
  }

  .info-right {
    position: relative;

    .right-look {
      width: 520px;
      height: 46px;
      color: $light-gray-color;
      background: rgba($light-gray-color, 0.1);
      border-radius: 4px;
      position: absolute;
      bottom: 0;

      .arrow {
        background: url('~/assets/images/tracker/icon-arrow1.webp') no-repeat;
        display: block;
        width: 18px;
        height: 18px;
      }

      .arrowUp {
        transform: rotateX(180deg);
      }

      &:hover {
        color: $primary-color;
        background: rgba($primary-color, 0.1);

        .arrow {
          background: url('~/assets/images/tracker/icon-arrow2.webp') no-repeat;
        }
      }
    }
  }
  .btn-share {
    .share-btn {
      width: 255px;
      height: 46px;
      border-radius: 10px;
      border: 1px solid #0252d9;
      color: #0252d9;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .share-btn:hover {
      transform: scale(1.02);
    }
  }

  .animation-height {
    transition: height 0.3s ease;
  }

  @keyframes loading {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
.el-message {
  z-index: 9999 !important;
}
</style>
